import { ScrollB } from './scroll-b'
import { AnimateBox } from '../../components/animate-box'

interface SectionEProps {
  title: string
}
export const SectionF = ({ title }: SectionEProps) => {
  return (
    <>
      <div className='title-box'>
        <AnimateBox tagName='h2'>{title}</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          服务航天科技、航天科工、航空工业、中国商飞、中国航发、中核集团、BYD、CATL等龙头企业，联合北航等高校及科研院所，共建自主工业软件创新生态
        </AnimateBox>
      </div>
      <AnimateBox>
        <ScrollB />
      </AnimateBox>
    </>
  )
}
